import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input, Button } from 'reactstrap';

class CommentForm extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.save = this.save.bind(this);
    this.state = { comment: '' };
  }

  onChange(e) {
    this.setState({ comment: e.target.value });
  }

  save() {
    this.props.onSave(this.state.comment, () => this.setState({ comment: '' }));
  }

  render() {
    return (
      <div className="d-flex">
        <Input
          placeholder="Post an update"
          onChange={this.onChange}
          value={this.state.comment}
          required
          autoFocus
        />
        <Button className="ml-3" color="primary" onClick={this.save}>
          Post
        </Button>
      </div>
    );
  }
}

CommentForm.propTypes = {
  onSave: PropTypes.func,
};

export default CommentForm;
